import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

function ContentMedia({ blocks, columns })
{
  if (columns === 2){   
    return (
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 max-w-4xl mx-auto pb-16 px-8">
      {blocks.map((block) => (
        <GatsbyImage key={block.id} image={getImage(block.image)} alt={block.image.alt || "TODO"} />
        ))}
    </div>
    )
  }
  else
  {
    return (
      <div className="max-w-4xl mx-auto pb-16 px-8">
        <GatsbyImage key={blocks[0].id} image={getImage(blocks[0].image)} alt={blocks[0].image.alt || "TODO"} />
      </div>
    )
  }

  // switch (style)
  // {
  //   case "Werkgevers | Intro":
  //     return (
  //       <div className="relative h-64 z-0">
  //         <GatsbyImage
  //           image={getImage(image)}
  //           alt="TODO"
  //           className=" absolute w-full h-80 overflow-y-hidden"
  //         />
  //       </div>
  //     )
  //   default:

  //     return (

  //       <GatsbyImage image={getImage(image)} alt="TODO" className="w-full" />
  //     );
  // }

}

export default ContentMedia;